module.exports = __WEBPACK_EXTERNAL_MODULE__3767__;